// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Atom_Cta = require("../../atom/Atom_Cta.bs.js");
var Emac_Menus = require("../../../emac/Emac_Menus.bs.js");
var Atom_Divider = require("../../atom/Atom_Divider.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");

function Organism_SettingsMenu$Button(Props) {
  var href = Props.href;
  var display = Particle_Screen_Ds.make(undefined, undefined, undefined, "flex", undefined, "none");
  return React.createElement(Atom_Cta.Link.make, {
              href: href,
              style: {
                TAG: /* Header */10,
                _0: {
                  TAG: /* SettingsMenu */9,
                  _0: display
                }
              }
            });
}

var Button = {
  make: Organism_SettingsMenu$Button
};

Organism_SettingsMenu$Button.displayName = "Organism_SettingsMenu.Button";

function Organism_SettingsMenu$Link(Props) {
  var data = Emac_Menus.toDsNavigation(undefined, undefined);
  var settings = data.Settings;
  var display = Particle_Screen_Ds.make(undefined, undefined, undefined, "none", undefined, "flex");
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Divider.make, {
                  style: Atom_Divider.menuNavigation,
                  display: Particle_Screen_Ds.make(undefined, undefined, "none", undefined, undefined, "inlineFlex")
                }), React.createElement(Atom_Cta.Link.make, {
                  href: settings.href,
                  label: settings.title,
                  style: {
                    TAG: /* Header */10,
                    _0: {
                      TAG: /* SettingsMenuLink */10,
                      _0: display
                    }
                  }
                }));
}

var Link = {
  make: Organism_SettingsMenu$Link
};

exports.Button = Button;
exports.Link = Link;
/*  Not a pure module */
